import React, { Dispatch, SetStateAction, useMemo } from "react";

import ReactDatePicker, {
  registerLocale,
  setDefaultLocale,
} from "react-datepicker";

import pt from "date-fns/locale/pt-BR";

import "react-datepicker/dist/react-datepicker.css";

import {
  Button,
  ButtonsWrap,
  CalendarWrap,
  Container,
  ContainerCalendar,
  ContainerWrap,
  DateText,
  Header,
  YearText,
} from "./styles";

registerLocale("pt", pt);
setDefaultLocale("pt");

type CustomDatePickerProps = {
  buttonOk: () => void;
  buttonCancel: () => void;
  selectedDate: Date | string;
  setSelectedDate: Dispatch<SetStateAction<Date>>;
  minDate?: Date;
  maxDate?: Date;
};

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  buttonOk,
  buttonCancel,
  selectedDate,
  setSelectedDate,
  minDate,
  maxDate,
}) => {
  const year = useMemo(() => {
    if (selectedDate) {
      const year = new Date(selectedDate);
      return year.getFullYear();
    }
    return "";
  }, [selectedDate]);

  const month = useMemo(() => {
    if (selectedDate) {
      const months = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ];
      const month = new Date(selectedDate);
      return months[month.getMonth()];
    }
    return "";
  }, [selectedDate]);

  const weekDay = useMemo(() => {
    if (selectedDate) {
      const weekDays = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
      const week = new Date(selectedDate);
      return weekDays[week.getDay()];
    }
    return "";
  }, [selectedDate]);

  const day = useMemo(() => {
    if (selectedDate) {
      const day = new Date(selectedDate);
      return day.getDate();
    }
    return "";
  }, [selectedDate]);

  return (
    <Container>
      <ContainerWrap>
        <Header>
          <YearText>{year}</YearText>
          <DateText>{`${weekDay}, ${day} ${month}`}</DateText>
        </Header>
        <CalendarWrap>
          <ContainerCalendar>
            <ReactDatePicker
              selected={selectedDate}
              onChange={setSelectedDate}
              inline
              formatWeekDay={(nameOfDay) =>
                nameOfDay.substr(0, 1).toUpperCase()
              }
              minDate={minDate}
              maxDate={maxDate}
            />
          </ContainerCalendar>
          <ButtonsWrap>
            <Button type="button" onClick={buttonCancel}>
              CANCEL
            </Button>
            <Button type="button" onClick={buttonOk}>
              OK
            </Button>
          </ButtonsWrap>
        </CalendarWrap>
      </ContainerWrap>
    </Container>
  );
};

export default CustomDatePicker;
